import { render, staticRenderFns } from "./amostraIncidencia.vue?vue&type=template&id=01698d58&"
import script from "./amostraIncidencia.vue?vue&type=script&lang=js&"
export * from "./amostraIncidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports